import React from "react";

export default function WhistleBlowingForm(){
    return (
        <div className="container-7">
            <div className="section-title text-center">
                <h2 className="text-header">Laporkan Pelanggaran</h2>
                <p className="text-justify md:text-center pb-10">Apabila Anda mengetahui adanya tindakan yang melanggar hukum, etika, atau ketentuan internal yang melibatkan pihak terkait dengan Danai.id, silakan sampaikan laporan Anda melalui tombol berikut:</p>
                <a href={`${process.env.REACT_APP_LINK_PORTAL}/whistle-blowing.xhtml`} className="btn-danai whistle-blowing justify-self-center">KIRIM FORM LAPORAN</a>
            </div>
        </div>
    );
}